const LOGO_URL = "/logo.png";

export function BobaLogo({ className = "w-10 h-10", alt = "The Boba Place" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={`${className} object-contain select-none`}
      draggable="false"
    />
  );
}

export { LOGO_URL };
